import {registerFrameMessageHandler} from "../iframeCommunication";

const cookieCodeRegister = {};

function registerAllowCookieMessageHandler(code, handler) {
  if(typeof code !== 'string') {
    throw new Error("Cookie code must be of type string");
  }
  if(typeof handler !== 'function') {
    throw new Error("Cookie handler must be of type function");
  }
  cookieCodeRegister[code] = handler;
}

function handleMessage(message) {
  const cookieCode = message.cookieCode ?? null;
  if(cookieCode === null) {
    console.warn("[seltmann-cms-allow-cookie] Received seltmann-cms-allow-cookie message without a cookie code, ignoring.");
    return;
  }

  if(typeof cookieCodeRegister[cookieCode]!== 'function') {
    // no handler registered, ignoring
    return;
  }
  const handler = cookieCodeRegister[cookieCode];
  handler(message);
}

function setUpAllowCookieMessageHandler() {
  registerFrameMessageHandler('seltmann-cms-allow-cookie', handleMessage);
}

export {setUpAllowCookieMessageHandler, registerAllowCookieMessageHandler};
